/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminTicketScan } from './AdminTicketScan';
import {
    AdminTicketScanFromJSON,
    AdminTicketScanFromJSONTyped,
    AdminTicketScanToJSON,
} from './AdminTicketScan';

/**
 * 
 * @export
 * @interface AdminTicketScans
 */
export interface AdminTicketScans {
    /**
     * 
     * @type {boolean}
     * @memberof AdminTicketScans
     */
    truncated: boolean;
    /**
     * 
     * @type {Array<AdminTicketScan>}
     * @memberof AdminTicketScans
     */
    scans: Array<AdminTicketScan>;
}

/**
 * Check if a given object implements the AdminTicketScans interface.
 */
export function instanceOfAdminTicketScans(value: object): value is AdminTicketScans {
    if (!('truncated' in value) || value['truncated'] === undefined) return false;
    if (!('scans' in value) || value['scans'] === undefined) return false;
    return true;
}

export function AdminTicketScansFromJSON(json: any): AdminTicketScans {
    return AdminTicketScansFromJSONTyped(json, false);
}

export function AdminTicketScansFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminTicketScans {
    if (json == null) {
        return json;
    }
    return {
        
        'truncated': json['truncated'],
        'scans': ((json['scans'] as Array<any>).map(AdminTicketScanFromJSON)),
    };
}

export function AdminTicketScansToJSON(value?: AdminTicketScans | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'truncated': value['truncated'],
        'scans': ((value['scans'] as Array<any>).map(AdminTicketScanToJSON)),
    };
}

